import { S3_URL, USER_TYPES } from 'constants/index';
import useTranslate from 'hooks/useTranslate';
import React from 'react';
import { Dropdown, Image, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useGetLanguageListQuery } from 'services';
import useLocalizationStore from 'store/localization';
import { languageCode } from 'utils';
import { changeLanguage } from 'services/base.service';

const PublicHeader: React.FC = () => {
	const { translate } = useTranslate();
	const { data: { language = [] } = {} } = useGetLanguageListQuery();
	const { activeLanguage, setActiveLanguage }: any = useLocalizationStore((state) => state);
	const selectedLang = language.find((data: any) => data.slug === activeLanguage);

	return (
		<Nav id="responsive-navbar-nav" className="justify-content-end flex-1 bg-white">
			<Nav className="gap-1 gap-md-3 align-items-center">
				{selectedLang && (
					<Dropdown className="language-selector">
						<Dropdown.Toggle id="dropdown-basic" className="bg-transparent p-0 border-0 w-auto">
							<Image
								src={`${S3_URL}${selectedLang?.image}`}
								alt="flag"
								className="h-auto me-1"
								loading="lazy"
							/>{' '}
							<span>{selectedLang?.title}</span>
						</Dropdown.Toggle>

						<Dropdown.Menu>
							{language?.length > 0 &&
								language.map((lang: any) => (
									<Dropdown.Item
										className={`${languageCode[lang?.title] === selectedLang?.code ? 'active' : ''} `}
										key={lang.code}
										onClick={() => {
											changeLanguage(lang?.slug);
											setActiveLanguage(lang?.slug);
										}}
									>
										<Image
											src={`${S3_URL}${lang?.image}`}
											alt="flag"
											className="h-auto me-1"
											loading="lazy"
										/>
										{lang?.title}
									</Dropdown.Item>
								))}
						</Dropdown.Menu>
					</Dropdown>
				)}
				<Nav.Link
					as={Link}
					className="btn filled-btn rounded-pill text-light"
					to={`/login?userType=${USER_TYPES.SEEKER}`}
				>
					{translate('Header.loginAsUser')}
				</Nav.Link>
				<Nav.Link
					as={Link}
					className="btn filled-btn rounded-pill text-light"
					to={`/login?userType=${USER_TYPES.COMPANY}`}
				>
					{translate('Header.loginAsRecruiter')}
				</Nav.Link>
			</Nav>
		</Nav>
	);
};

export default PublicHeader;
